import React from 'react'

import { Row, Col } from '_zari/core'

import { RounderUtil } from 'utils'

import * as FormGroups from './formGroups'

const InfoDiferenciasSection = ({ vMontoTotal, letras }) => {
  const infoDiferencias = React.useMemo(() => {
    let sumaLetras = 0
    if (letras && letras.length > 0) {
      sumaLetras = letras.reduce((suma, current) => RounderUtil.round(suma + parseFloat(current.importe)), 0)
    }

    const diferencia = RounderUtil.round(vMontoTotal - sumaLetras)

    return {
      montoTotal: vMontoTotal,
      montoLetras: sumaLetras,
      diferencia: diferencia
    }
  }, [vMontoTotal, letras])

  return (
    <Row className='zari-slim-form'>
      <Col md={4}>
        <FormGroups.MontoTotalFormGroup iValue={infoDiferencias.montoTotal} />
      </Col>
      <Col md={4}>
        <FormGroups.MontoLetrasFormGroup iValue={infoDiferencias.montoLetras} />
      </Col>
      {infoDiferencias.diferencia !== 0 && (
        <Col md={4}>
          <FormGroups.DiferenciaFormGroup iValue={infoDiferencias.diferencia} />
        </Col>
      )}
    </Row>
  )
}

export default React.memo(InfoDiferenciasSection)
